import cell from './cell';
var row = {
    getTemplate: function (r) {
        var cells = r.cells;
        return {
            name: "Row",
            children: cells.map(function (it) { return cell.getTemplate(it); })
        };
    }
};
export default row;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ag-grid-enterprise/excel-export/dist/es6/excelExport/files/xml/row.js
// module id = 3131
// module chunks = 0